export default __webpack_public_path__ + "static/media/logo.611cbae2.svg";